import { css } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { useAppRoutes } from '@root/features/routing'

import { reatomReferralLeaderboardTable } from '../../atoms'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const ReferralLeaderboardTable: React.FC<Props> = ({ className }) => {
  const { navigateUserProfile } = useAppRoutes()
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomReferralLeaderboardTable(), [])

  return (
    <AppDataTable
      onRowClick={(entry) => {
        navigateUserProfile(entry.userId)
      }}
      className={className}
      css={css`
        height: 100%;
      `}
      model={model}
      rowHeight={40}
    />
  )
}
